import { useSelector } from "react-redux";
import { RootState } from "../../../../../../stores/store";
import { PaymentPlan } from "../../../../../../service/contract/solar-recommendation";
import { RecommendationProductCard } from "./recommendation-product-card";
import styles from "./recommendations-page.module.scss";

interface Props {
	onContinue: () => void;
}

export const RecommendationsPage: React.FC<Props> = ({ onContinue }) => {
	const recommendationDetails = useSelector((state: RootState) => state.getSolar.recommendationDetails);

	const products = recommendationDetails?.assessmentDetails?.recommendedProducts ?? [];
	const paymentPlan = recommendationDetails?.assessmentDetails?.paymentPlan ?? PaymentPlan.Undefined;

	return (
		<div className={styles.container}>
			<h2 className={styles.title}>Tailored Recommendation</h2>
			<p className={styles.subtitle}>
				Tailored Product Recommendations from Your Data.
			</p>
			<div className={styles.grid}>
				{products.map(product => (
					<RecommendationProductCard
						key={product.id}
						product={product}
						paymentPlan={paymentPlan}
						onContinue={onContinue}
					/>
				))}
			</div>
		</div>
	);
};
